import angular from 'angular';
import { MeurhSolicitacoesgenericasService } from './solicitacoesgenericas.service';

export const MeurhSolicitacoesgenericasListRouting = [
    '$stateProvider',
    function($stateProvider: angular.ui.IStateProvider) {
        const resolve = {
            'entity': [
                'MeurhSolicitacoesgenericasService',
                '$rootScope',
                '$stateParams',
                '$state',
                '$q',
                function(
                    entityService: MeurhSolicitacoesgenericasService,
                    $rootScope: angular.IRootScopeService & { session: any },
                    $stateParams: angular.ui.IStateParamsService,
                    $state: angular.ui.IStateService,
                    $q: angular.IQService
                ) {
                    if (!$stateParams['solicitacao']) {
                        return $q<void>(() => $state.go('meurh_solicitacoesgenericas'));
                    }

                    return entityService.get($stateParams['solicitacao'])
                        .then((data) => {
                            const deveRedirecionar = data.estabelecimento.estabelecimento !== $rootScope.session.entities.estabelecimento.estabelecimento;
                            if (deveRedirecionar) {
                                return $q(() => $state.go('meurh_solicitacoesgenericas'));
                            }

                            return data;
                        })
                        .catch((error) => {
                            if (error.status === 404) {
                                return $q(() => {
                                    if ($state.href('meurh_solicitacoesgenericas_not_found', $stateParams)) {
                                        $state.go('meurh_solicitacoesgenericas_not_found', $stateParams);
                                    } else {
                                        $state.go('not_found', $stateParams);
                                    }
                                });
                            }

                            return $q.reject(error);
                        });
                }
            ]
        };

        $stateProvider
            .state('meurh_solicitacoesgenericas', {
                url: '/solicitacoes/genericas',
                template: require('html-loader!./index/solicitacoesgenericas.index.html'),
                controller: 'Meurh\SolicitacoesgenericasIndexController',
                controllerAs: 'mrh_solicitacoesgenericas_lst_cntrllr',
                reloadOnSearch: false
            })
            .state('meurh_solicitacoesgenericas_new', {
                url: '/solicitacoes/genericas/new',
                template: require('html-loader!./new/solicitacoesgenericas.new.html'),
                controller: 'MeurhSolicitacoesgenericasNewController',
                controllerAs: 'mrh_solicitacoesgenericas_frm_nw_cntrllr'
            })
            .state('meurh_solicitacoesgenericas_get', {
                url: '/solicitacoes/genericas/show/:solicitacao?path',
                resolve,
                template: require('html-loader!./show/solicitacoesgenericas.show.html'),
                controller: 'MeurhSolicitacoesgenericasShowController',
                controllerAs: 'mrh_solicitacoesgenericas_frm_shw_cntrllr'
            });
    }
];
